<template>
    <component :is="hn" class="title">
        {{ content }}
    </component>
</template>

<script setup>

const props = defineProps({
    content: {
        type: String,
        required: true
    },
    hn: {
        type: String,
        default: 'h2',
        validator: value => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
    }
})
</script>

<style lang="scss" scoped>
.title {
    font-weight: bold;
    margin-bottom: 1rem;
    // Ajoutez vos styles ici
}
</style>